<template>
    <ul class="menu-nav">
        <!-- NOTE - Solo link template -->
        <!-- SECTION - Dashboard -->
        <router-link to="/dashboard" v-slot="{ href, navigate, isActive, isExactActive }">
            <li
                aria-haspopup="true"
                data-menu-toggle="hover"
                class="menu-item"
                :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']"
            >
                <a :href="href" class="menu-link" @click="navigate">
                    <span class="menu-text"> Dashboard </span>
                </a>
            </li>
        </router-link>
        <!-- SECTION - Subscribe -->
        <router-link to="/subscribe" v-slot="{ href, navigate, isActive, isExactActive }">
            <li
                aria-haspopup="true"
                data-menu-toggle="hover"
                class="menu-item"
                :class="[isActive && 'menu-item-active', isExactActive && 'menu-item-active']"
            >
                <a :href="href" class="menu-link" @click="navigate">
                    <span class="menu-text">
                        <i class="fas fa-shopping-cart mr-2 text-white"></i> Subscribe
                    </span>
                </a>
            </li>
        </router-link>

        <!-- NOTE - Dropdown template -->
        <!-- SECTION - Search hashtags -->
        <li
            aria-haspopup="true"
            data-menu-toggle="click"
            class="menu-item menu-item-submenu menu-item-open-dropdown"
            v-bind:class="{
                'menu-item-active': hasActiveChildrenArray([
                    '/search',
                    '/lite',
                    '/bulk',
                    '/relevant',
                    '/viralsearch',
                    '/viralfinder',
                    '/banned',
                ]),
            }"
        >
            <a href="#" class="menu-link menu-toggle">
                <span class="menu-text"> Search Hashtags </span>
            </a>
            <div class="menu-submenu menu-submenu-classic">
                <ul class="menu-subnav">
                    <!-- New template -->
                    <template v-if="!isPremium">
                        <router-link
                            to="/lite"
                            v-slot="{ href, navigate, isActive, isExactActive }"
                        >
                            <li
                                aria-haspopup="true"
                                data-menu-toggle="hover"
                                class="menu-item"
                                :class="[
                                    isActive && 'menu-item-active',
                                    isExactActive && 'menu-item-active',
                                ]"
                            >
                                <a :href="href" class="menu-link" @click="navigate">
                                    <i class="menu-icon fas fa-search"></i>
                                    <span class="menu-text text-success font-weight-bolder">
                                        Lite Search
                                    </span>
                                    <span class="menu-label">
                                        <span class="label label-danger label-inline">FREE</span>
                                    </span>
                                </a>
                            </li>
                        </router-link>
                    </template>
                    <router-link to="/search" v-slot="{ href, navigate, isActive, isExactActive }">
                        <li
                            aria-haspopup="true"
                            data-menu-toggle="hover"
                            class="menu-item"
                            :class="[
                                isActive && 'menu-item-active',
                                isExactActive && 'menu-item-active',
                            ]"
                        >
                            <a :href="href" class="menu-link" @click="navigate">
                                <i class="menu-icon fas fa-search"></i>
                                <span class="menu-text"> Search </span>
                            </a>
                        </li>
                    </router-link>
                    <router-link to="/bulk" v-slot="{ href, navigate, isActive, isExactActive }">
                        <li
                            aria-haspopup="true"
                            data-menu-toggle="hover"
                            class="menu-item"
                            :class="[
                                isActive && 'menu-item-active',
                                isExactActive && 'menu-item-active',
                            ]"
                        >
                            <a :href="href" class="menu-link" @click="navigate">
                                <i class="menu-icon fas fa-upload"></i>
                                <span class="menu-text"> Bulk </span>
                            </a>
                        </li>
                    </router-link>
                    <router-link
                        to="/relevant"
                        v-slot="{ href, navigate, isActive, isExactActive }"
                    >
                        <li
                            aria-haspopup="true"
                            data-menu-toggle="hover"
                            class="menu-item"
                            :class="[
                                isActive && 'menu-item-active',
                                isExactActive && 'menu-item-active',
                            ]"
                        >
                            <a :href="href" class="menu-link" @click="navigate">
                                <i class="menu-icon fas fa-project-diagram"></i>
                                <span class="menu-text"> Relevant Tags </span>
                            </a>
                        </li>
                    </router-link>
                    <router-link
                        to="/viralsearch"
                        v-slot="{ href, navigate, isActive, isExactActive }"
                    >
                        <li
                            aria-haspopup="true"
                            data-menu-toggle="hover"
                            class="menu-item"
                            :class="[
                                isActive && 'menu-item-active',
                                isExactActive && 'menu-item-active',
                            ]"
                        >
                            <a :href="href" class="menu-link" @click="navigate">
                                <i class="menu-icon fas fa-fire-alt text-warning"></i>
                                <span class="menu-text"> Viral Search Engine </span>
                            </a>
                        </li>
                    </router-link>
                    <router-link
                        to="/viralfinder"
                        v-slot="{ href, navigate, isActive, isExactActive }"
                    >
                        <li
                            aria-haspopup="true"
                            data-menu-toggle="hover"
                            class="menu-item"
                            :class="[
                                isActive && 'menu-item-active',
                                isExactActive && 'menu-item-active',
                            ]"
                        >
                            <a :href="href" class="menu-link" @click="navigate">
                                <i class="menu-icon fas fa-fire-alt"></i>
                                <span class="menu-text"> Viral Media Finder </span>
                            </a>
                        </li>
                    </router-link>
                    <router-link to="/banned" v-slot="{ href, navigate, isActive, isExactActive }">
                        <li
                            aria-haspopup="true"
                            data-menu-toggle="hover"
                            class="menu-item"
                            :class="[
                                isActive && 'menu-item-active',
                                isExactActive && 'menu-item-active',
                            ]"
                        >
                            <a :href="href" class="menu-link" @click="navigate">
                                <i class="menu-icon fas fa-times"></i>
                                <span class="menu-text"> Banned Hashtags </span>
                            </a>
                        </li>
                    </router-link>
                </ul>
            </div>
        </li>
        <!-- END Section - Hashtags -->
        <!-- SECTION - Manage Hashtags -->
        <li
            aria-haspopup="true"
            data-menu-toggle="click"
            class="menu-item menu-item-submenu menu-item-open-dropdown"
            v-bind:class="{
                'menu-item-active': hasActiveChildrenArray(['/myhashtags', '/shuffle']),
            }"
        >
            <a href="#" class="menu-link menu-toggle">
                <span class="menu-text"> Manage Hashtags </span>
            </a>
            <div class="menu-submenu menu-submenu-classic">
                <ul class="menu-subnav">
                    <!-- New template -->
                    <router-link
                        to="/myhashtags"
                        v-slot="{ href, navigate, isActive, isExactActive }"
                    >
                        <li
                            aria-haspopup="true"
                            data-menu-toggle="hover"
                            class="menu-item"
                            :class="[
                                isActive && 'menu-item-active',
                                isExactActive && 'menu-item-active',
                            ]"
                        >
                            <a :href="href" class="menu-link" @click="navigate">
                                <i class="menu-icon far fa-star"></i>
                                <span class="menu-text"> MyHashtags </span>
                            </a>
                        </li>
                    </router-link>
                    <router-link to="/shuffle" v-slot="{ href, navigate, isActive, isExactActive }">
                        <li
                            aria-haspopup="true"
                            data-menu-toggle="hover"
                            class="menu-item"
                            :class="[
                                isActive && 'menu-item-active',
                                isExactActive && 'menu-item-active',
                            ]"
                        >
                            <a :href="href" class="menu-link" @click="navigate">
                                <i class="menu-icon fas fa-random"></i>
                                <span class="menu-text"> Hashtag Shuffle </span>
                            </a>
                        </li>
                    </router-link>
                </ul>
            </div>
        </li>
        <!-- END Section - Manage -->
        <!-- SECTION - Manage Accounts -->
        <li
            aria-haspopup="true"
            data-menu-toggle="click"
            class="menu-item menu-item-submenu menu-item-open-dropdown"
            v-bind:class="{
                'menu-item-active': hasActiveChildrenArray([
                    '/accountdashboard',
                    '/mycampaigns',
                    '/myaccounts',
                    '/accountscanner',
                    '/accountinsights',
                ]),
            }"
        >
            <a href="#" class="menu-link menu-toggle">
                <span class="menu-text"> Accounts </span>
            </a>
            <div class="menu-submenu menu-submenu-classic">
                <ul class="menu-subnav">
                    <!-- New template -->
                    <router-link
                        to="/accountdashboard"
                        v-slot="{ href, navigate, isActive, isExactActive }"
                    >
                        <li
                            aria-haspopup="true"
                            data-menu-toggle="hover"
                            class="menu-item"
                            :class="[
                                isActive && 'menu-item-active',
                                isExactActive && 'menu-item-active',
                            ]"
                        >
                            <a :href="href" class="menu-link" @click="navigate">
                                <i class="menu-icon fas fa-address-book"></i>
                                <span class="menu-text"> Account Dashboard </span>
                                <span class="menu-label">
                                    <span class="label label-success label-inline">NEW</span>
                                </span>
                            </a>
                        </li>
                    </router-link>
                    <router-link
                        to="/mycampaigns"
                        v-slot="{ href, navigate, isActive, isExactActive }"
                    >
                        <li
                            aria-haspopup="true"
                            data-menu-toggle="hover"
                            class="menu-item"
                            :class="[
                                isActive && 'menu-item-active',
                                isExactActive && 'menu-item-active',
                            ]"
                        >
                            <a :href="href" class="menu-link" @click="navigate">
                                <i class="menu-icon fas fa-vector-square text-danger"></i>
                                <span class="menu-text"> Hashtag Performance Campaigns </span>
                            </a>
                        </li>
                    </router-link>
                    <router-link
                        to="/myaccounts"
                        v-slot="{ href, navigate, isActive, isExactActive }"
                    >
                        <li
                            aria-haspopup="true"
                            data-menu-toggle="hover"
                            class="menu-item"
                            :class="[
                                isActive && 'menu-item-active',
                                isExactActive && 'menu-item-active',
                            ]"
                        >
                            <a :href="href" class="menu-link" @click="navigate">
                                <i class="menu-icon fas fa-user-friends"></i>
                                <span class="menu-text"> My Accounts </span>
                            </a>
                        </li>
                    </router-link>
                    <router-link
                        to="/accountscanner"
                        v-slot="{ href, navigate, isActive, isExactActive }"
                    >
                        <li
                            aria-haspopup="true"
                            data-menu-toggle="hover"
                            class="menu-item"
                            :class="[
                                isActive && 'menu-item-active',
                                isExactActive && 'menu-item-active',
                            ]"
                        >
                            <a :href="href" class="menu-link" @click="navigate">
                                <i class="menu-icon fas fa-user-cog"></i>
                                <span class="menu-text"> Account Scanner </span>
                            </a>
                        </li>
                    </router-link>
                    <router-link
                        to="/accountinsights"
                        v-slot="{ href, navigate, isActive, isExactActive }"
                    >
                        <li
                            aria-haspopup="true"
                            data-menu-toggle="hover"
                            class="menu-item"
                            :class="[
                                isActive && 'menu-item-active',
                                isExactActive && 'menu-item-active',
                            ]"
                        >
                            <a :href="href" class="menu-link" @click="navigate">
                                <i class="menu-icon fas fa-table"></i>
                                <span class="menu-text"> Instagram Insights </span>
                                <span class="menu-label">
                                    <span class="label label-danger label-inline">BETA</span>
                                </span>
                            </a>
                        </li>
                    </router-link>
                </ul>
            </div>
        </li>
        <!-- END Section - Manage -->
        <!-- SECTION - Other -->
        <li
            aria-haspopup="true"
            data-menu-toggle="click"
            class="menu-item menu-item-submenu menu-item-open-dropdown"
            v-bind:class="{
                'menu-item-active': hasActiveChildrenArray([
                    '/profile',
                    '/affiliates',
                    '/faq',
                    '/support',
                ]),
            }"
        >
            <a href="#" class="menu-link menu-toggle">
                <span class="menu-text"> Other </span>
            </a>
            <div class="menu-submenu menu-submenu-classic">
                <ul class="menu-subnav">
                    <!-- New template -->
                    <router-link to="/profile" v-slot="{ href, navigate, isActive, isExactActive }">
                        <li
                            aria-haspopup="true"
                            data-menu-toggle="hover"
                            class="menu-item"
                            :class="[
                                isActive && 'menu-item-active',
                                isExactActive && 'menu-item-active',
                            ]"
                        >
                            <a :href="href" class="menu-link" @click="navigate">
                                <i class="menu-icon fas fa-user-circle"></i>
                                <span class="menu-text"> User Profile </span>
                            </a>
                        </li>
                    </router-link>
                    <router-link
                        to="/affiliates"
                        v-slot="{ href, navigate, isActive, isExactActive }"
                    >
                        <li
                            aria-haspopup="true"
                            data-menu-toggle="hover"
                            class="menu-item"
                            :class="[
                                isActive && 'menu-item-active',
                                isExactActive && 'menu-item-active',
                            ]"
                        >
                            <a :href="href" class="menu-link" @click="navigate">
                                <i class="menu-icon fas fa-award"></i>
                                <span class="menu-text"> Affiliates </span>
                            </a>
                        </li>
                    </router-link>
                    <router-link to="/faq" v-slot="{ href, navigate, isActive, isExactActive }">
                        <li
                            aria-haspopup="true"
                            data-menu-toggle="hover"
                            class="menu-item"
                            :class="[
                                isActive && 'menu-item-active',
                                isExactActive && 'menu-item-active',
                            ]"
                        >
                            <a :href="href" class="menu-link" @click="navigate">
                                <i class="menu-icon fas fa-info-circle"></i>
                                <span class="menu-text"> FAQ / Tutorial </span>
                            </a>
                        </li>
                    </router-link>
                    <router-link to="/support" v-slot="{ href, navigate, isActive, isExactActive }">
                        <li
                            aria-haspopup="true"
                            data-menu-toggle="hover"
                            class="menu-item"
                            :class="[
                                isActive && 'menu-item-active',
                                isExactActive && 'menu-item-active',
                            ]"
                        >
                            <a :href="href" class="menu-link" @click="navigate">
                                <i class="menu-icon fas fa-question"></i>
                                <span class="menu-text"> Support </span>
                            </a>
                        </li>
                    </router-link>
                </ul>
            </div>
        </li>
        <!-- END Section - Manage -->
        <!-- SECTION - ADMIN -->
        <template v-if="isAdmin">
            <li
                aria-haspopup="true"
                data-menu-toggle="click"
                class="menu-item menu-item-submenu menu-item-open-dropdown"
                v-bind:class="{
                    'menu-item-active': hasActiveChildrenArray([
                        '/admin',
                        '/admin-payments',
                        '/admin-statistics',
                        '/admin-tools',
                        '/admin-engines',
                    ]),
                }"
            >
                <a href="#" class="menu-link menu-toggle">
                    <span class="menu-text"> Admin </span>
                </a>
                <div class="menu-submenu menu-submenu-classic">
                    <ul class="menu-subnav">
                        <!-- New template -->
                        <router-link
                            to="/admin"
                            v-slot="{ href, navigate, isActive, isExactActive }"
                        >
                            <li
                                aria-haspopup="true"
                                data-menu-toggle="hover"
                                class="menu-item"
                                :class="[
                                    isActive && 'menu-item-active',
                                    isExactActive && 'menu-item-active',
                                ]"
                            >
                                <a :href="href" class="menu-link" @click="navigate">
                                    <i class="menu-icon fas fa-user-circle"></i>
                                    <span class="menu-text"> Admin </span>
                                </a>
                            </li>
                        </router-link>
                        <router-link
                            to="/admin-payments"
                            v-slot="{ href, navigate, isActive, isExactActive }"
                        >
                            <li
                                aria-haspopup="true"
                                data-menu-toggle="hover"
                                class="menu-item"
                                :class="[
                                    isActive && 'menu-item-active',
                                    isExactActive && 'menu-item-active',
                                ]"
                            >
                                <a :href="href" class="menu-link" @click="navigate">
                                    <i class="menu-icon fas fa-user-circle"></i>
                                    <span class="menu-text"> Payments </span>
                                </a>
                            </li>
                        </router-link>
                        <router-link
                            to="/admin-statistics"
                            v-slot="{ href, navigate, isActive, isExactActive }"
                        >
                            <li
                                aria-haspopup="true"
                                data-menu-toggle="hover"
                                class="menu-item"
                                :class="[
                                    isActive && 'menu-item-active',
                                    isExactActive && 'menu-item-active',
                                ]"
                            >
                                <a :href="href" class="menu-link" @click="navigate">
                                    <i class="menu-icon fas fa-server"></i>
                                    <span class="menu-text"> Statistics </span>
                                </a>
                            </li>
                        </router-link>
                        <router-link
                            to="/admin-tools"
                            v-slot="{ href, navigate, isActive, isExactActive }"
                        >
                            <li
                                aria-haspopup="true"
                                data-menu-toggle="hover"
                                class="menu-item"
                                :class="[
                                    isActive && 'menu-item-active',
                                    isExactActive && 'menu-item-active',
                                ]"
                            >
                                <a :href="href" class="menu-link" @click="navigate">
                                    <i class="menu-icon fas fa-tools"></i>
                                    <span class="menu-text"> Tools </span>
                                </a>
                            </li>
                        </router-link>
                        <router-link
                            to="/admin-engines"
                            v-slot="{ href, navigate, isActive, isExactActive }"
                        >
                            <li
                                aria-haspopup="true"
                                data-menu-toggle="hover"
                                class="menu-item"
                                :class="[
                                    isActive && 'menu-item-active',
                                    isExactActive && 'menu-item-active',
                                ]"
                            >
                                <a :href="href" class="menu-link" @click="navigate">
                                    <i class="menu-icon fas fa-cogs"></i>
                                    <span class="menu-text"> Engine Room </span>
                                </a>
                            </li>
                        </router-link>
                        <li aria-haspopup="true" data-menu-toggle="hover" class="menu-item">
                            <a
                                href="https://api.hashtastic.eu/logs"
                                target="_blank"
                                class="menu-link"
                            >
                                <i class="menu-icon fas fa-box"></i>
                                <span class="menu-text"> Prod Laravel Logs </span>
                            </a>
                        </li>
                        <li aria-haspopup="true" data-menu-toggle="hover" class="menu-item">
                            <a
                                href="https://api-dev.hashtastic.eu/logs"
                                target="_blank"
                                class="menu-link"
                            >
                                <i class="menu-icon fas fa-box"></i>
                                <span class="menu-text"> Dev Laravel Logs </span>
                            </a>
                        </li>
                    </ul>
                </div>
            </li>
            <!-- END Section - Manage -->
        </template>
    </ul>
</template>

<script>
import { mapGetters } from "vuex";
export default {
    name: "KTMenu",
    computed: {
        ...mapGetters({
            currentUser: "auth/currentUser",
            isAdmin: "auth/isAdmin",
            isPremium: "auth/isPremium",
        }),
    },
    methods: {
        hasActiveChildren(match) {
            return this.$route["path"].indexOf(match) !== -1;
        },
        hasActiveChildrenArray(array) {
            return array.indexOf(this.$route["path"]) !== -1;
        },
    },
};
</script>
